"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var colors_1 = require("../../constants/colors");
var utils_1 = require("../../utils");
var SVG = styled_components_1.default.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  opacity: ", ";\n\n  &:hover {\n    cursor: pointer;\n\n    .ticket {\n      fill: ", ";\n    }\n\n    .count {\n        color: ", "\n    }\n  }\n\n  .ticket {\n    fill: ", ";\n    stroke: ", ";\n    stroke-width: 2px;\n  }\n\n  .count {\n    font-weight: bold;\n    color: ", ";\n  }\n"], ["\n  opacity: ", ";\n\n  &:hover {\n    cursor: pointer;\n\n    .ticket {\n      fill: ", ";\n    }\n\n    .count {\n        color: ", "\n    }\n  }\n\n  .ticket {\n    fill: ",
    ";\n    stroke: ",
    ";\n    stroke-width: 2px;\n  }\n\n  .count {\n    font-weight: bold;\n    color: ",
    ";\n  }\n"])), function (_a) {
    var disabled = _a.disabled;
    return disabled ? '.2' : '1';
}, function (_a) {
    var theme = _a.theme, backgroundColor = _a.backgroundColor;
    return utils_1.parseThemePath(backgroundColor, theme, colors_1.colors.BLUE_MEDIUM_400);
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return utils_1.parseThemePath(color, theme, colors_1.colors.BLUE_MEDIUM_400);
}, function (_a) {
    var theme = _a.theme, backgroundColor = _a.backgroundColor, secondary = _a.secondary;
    return secondary ? 'none' : utils_1.parseThemePath(backgroundColor, theme, colors_1.colors.BLUE_MEDIUM_300);
}, function (_a) {
    var theme = _a.theme, backgroundColor = _a.backgroundColor, secondary = _a.secondary;
    return secondary ? utils_1.parseThemePath(backgroundColor, theme, colors_1.colors.BLUE_MEDIUM_300) : 'none';
}, function (_a) {
    var theme = _a.theme, color = _a.color, secondary = _a.secondary, backgroundColor = _a.backgroundColor;
    return secondary ? utils_1.parseThemePath(backgroundColor, theme, colors_1.colors.WHITE) : utils_1.parseThemePath(color, theme, colors_1.colors.WHITE);
});
var AXSTicketCount = function (_a) {
    var disabled = _a.disabled, count = _a.count, className = _a.className, props = __rest(_a, ["disabled", "count", "className"]);
    return (React.createElement(SVG, __assign({}, props, { disabled: disabled, "aria-label": count || '-', className: classnames_1.default(['c-axs-ticket-count', className]), width: "48", height: "28", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("g", { fill: "none" },
            React.createElement("path", { className: "ticket", d: "M1.1,18.7v8.3h45.7V1H1.1v8.3c2.4,0.5,4.2,2.4,4.2,4.7S3.5,18.2,1.1,18.7z" }),
            React.createElement("text", { className: "count", textAnchor: "middle", fill: "currentColor" },
                React.createElement("tspan", { className: "count", x: "24", y: "20" }, count === 0 ? count : count || null)))));
};
AXSTicketCount.defaultProps = {
    backgroundColor: 'axsui.components.ticketCount.backgroundColor',
    color: 'axsui.components.ticketCount.color',
};
exports.default = AXSTicketCount;
var templateObject_1;
//# sourceMappingURL=index.js.map